import styled from 'styled-components'
import { Type } from 'theme/types'

export const LegalAgeImg = styled.img`
  ${({ theme }: Type) => theme?.agegate?.img}
`
